import Load from 'components/Load';
import LoadingDots from 'components/LoadingDots';
import useIsMobile from 'hooks/useIsMobile';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import AppBottomPushDown from 'modules/common/Navbar/PushDown/AppBottomPushDown';
import Notfound from 'modules/errorpages/Notfound';
import LoggedOut from 'modules/user-environment2/components/LoggedOut';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import basePath from 'utils/basePath';
import { useUser } from '~/authentication/store';
import { useLang } from '~/stores/i18n';

const HostExperiencesPage = Load(
  () =>
    import(
      /* webpackChunkName: "host-experiences-overview" */ './containers/HostExperiencesPage'
    ),
);
const HostRecommendationsPage = Load(
  () =>
    import(
      /* webpackChunkName: "host-recommendations-overview" */ './containers/HostRecommendationsPage'
    ),
);
const AsyncPausedModal = Load(
  () =>
    import(
      /* webpackChunkName: "host-experiences-overview" */ './components/Modals/PauseModal'
    ),
);
const OriginalsDetailsPage = Load(
  () =>
    import(
      /* webpackChunkName: "host-experiences-originals-details" */ './containers/OriginalsDetailsPage'
    ),
);
const RecommendationDetailsPage = Load(
  () =>
    import(
      /* webpackChunkName: "host-experiences-recommendation-details" */ './containers/RecommendationDetailsPage'
    ),
);

const SubRoutes = () => {
  const { path } = useRouteMatch();
  const {
    isHost,
    isOnboardingHost,
    isOnboardingHostWebinar,
    isAdmin,
    loading,
    isLoggedIn,
  } = useUser();
  const lang = useLang();
  const isMobile = useIsMobile();

  if (!loading && !isLoggedIn) {
    return <LoggedOut title={'Login to view this content'} />;
  }

  if (loading) {
    return <LoadingDots />;
  }

  if (!isHost && !isOnboardingHost && !isOnboardingHostWebinar && !isAdmin) {
    return <Redirect to={generatePathnameWithLangCode('/', lang)} />;
  }

  return (
    <Switch>
      <NavigationableLayout
        key="host-experiences-recommendation-details"
        path={`${path}/recommendation/:id`}
        hideFooter
        component={RecommendationDetailsPage}
        noNavbar={isMobile}
        nonFixedNavbar
      />
      <NavigationableLayout
        key="host-recommendations-overview"
        path={`${path}/recommendations`}
        hideFooter
        component={HostRecommendationsPage}
        showBottomNavigation
        noNavbar={isMobile}
        nonFixedNavbar
      />
      <Route
        path={`${path}/paused-modal/:itineraryId`}
        component={AsyncPausedModal}
      />
      <NavigationableLayout
        key="host-experiences-originals-details"
        path={`${path}/:id`}
        hideFooter
        component={OriginalsDetailsPage}
        showBottomNavigation
        noNavbar={isMobile}
        nonFixedNavbar
      />
      <NavigationableLayout
        key="host-experiences-overview"
        path={`${path}/`}
        hideFooter
        component={HostExperiencesPage}
        showBottomNavigation
        noNavbar={isMobile}
        nonFixedNavbar
        exact
      />
      <Route>
        <Notfound />
      </Route>
    </Switch>
  );
};

const routes = (
  <Route path={`${basePath}/host/experiences`}>
    <>
      <SubRoutes />
      <AppBottomPushDown />
    </>
  </Route>
);

export default routes;
